import CreateDefaultWorkoutProfile from "@/components/FitnessProfile/CreateDefaultWorkoutProfile";
import { WahooWorkoutTypeFamily, WahooWorkoutTypeLocation } from "@WahooFitness/cloud-client-types";
import { useSearchParams } from "react-router-dom";

function CreateDefaultWorkoutProfilePage() {
  const [searchParams] = useSearchParams();
  const workoutTypeFamily = Number(searchParams.get("workoutTypeFamily")) as WahooWorkoutTypeFamily;
  const workoutLocation = Number(searchParams.get("workoutLocation")) as WahooWorkoutTypeLocation;
  return (
    <CreateDefaultWorkoutProfile
      workoutTypeFamily={workoutTypeFamily}
      workoutLocation={workoutLocation}
    />
  );
}

export default CreateDefaultWorkoutProfilePage;
